import { defineStore } from 'pinia';
import "vue3-toastify/dist/index.css";
import { toast, type ToastType } from 'vue3-toastify';

export const useUIStore = defineStore({
    id: 'ui',
    state: () => ({
        loading: false,
        doStop: {
            stop: false,
            msg: "",
            btnTitle: null as any,
            btnAction: null as any,
            img: null as any,
            imgProps: null as any,
        },
        snackbar: {
            message: '',
            color: '',
            show: false,
        }
    }),
    actions: {
        showMessage(type: ToastType, message: string) {
            toast(message, {
                theme: "auto",
                type,
            })
        },
        closeSnackbar() {
            this.snackbar.show = false;
        },
        startLoading() {
            this.loading = true;
        },
        stopLoading() {
            this.loading = false;
        },
        stopApp(
            msg: string, 
            btnTitle?: string, 
            btnAction?: Function, 
            img?: string,
            imgProps?: Partial<CSSStyleDeclaration>,
        ) {
            this.loading = false;
            this.doStop.stop = true;
            this.doStop.msg = msg;
            this.doStop.btnTitle = btnTitle;
            this.doStop.btnAction = btnAction;
            this.doStop.img = img;
            this.doStop.imgProps = imgProps;
        }
    },
});